"use client";

import React, { useState } from "react";
import BreadcrumbComp from "../../shared/BreadcrumbComp";
import {
  AiOutlineClockCircle,
  AiOutlineEnvironment,
  AiOutlineUser,
  AiOutlineDollarCircle,
} from "react-icons/ai";
import { Modal, Form, Input, Button, Upload, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import ReactParser from "html-react-parser";
import dayjs from "dayjs";
import handleUploadApi from "@/actions/handleUploadApi";
import handleCreateApi from "@/actions/handleCreateApi";
const RecruitmentDetail = ({ recruitment }) => {
  const breadcrumbItems = [
    { title: "Trang Chủ", href: "/" },
    { title: "Tuyển Dụng", href: "/tuyen-dung" },
    { title: "Chi tiết tuyển dụng", href: "#" },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [imageUrl, setImageUrl] = useState("");

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    form
      .validateFields()
      .then(async (values) => {
        try {
          const data = {
            ...values,
            fileCv: imageUrl,
            recruitmentId: recruitment?.id,
          };
          delete data.upload;
          const res = await handleCreateApi({ data, url: "/apply-contacts" });
          if (res.error) {
            message.error("Có lỗi xảy ra vui lòng thử lại!");
            return;
          }
          form.resetFields();
          setImageUrl("");
          setIsModalOpen(false);
          message.success("Nộp hồ sơ thành công!");
          // console.log("Received values of form: ", values);
        } catch (e) {
          // console.log(e);
        }
      })
      .catch((info) => {
        // console.log("Validate Failed:", info);
      });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
    setImageUrl("");
  };

  const customRequest = async ({ file, onSuccess, onProgress }) => {
    try {
      const formData = new FormData();
      await formData.append("file", file);
      const response = await handleUploadApi({
        data: formData,
        onProgress: onProgress,
      });
      setImageUrl(
        `${process.env.NEXT_PUBLIC_API_HOST.replace("/u", "")}/uploads/${encodeURIComponent(response[0]?.source)}`,
      );
      onSuccess("ok");
    } catch (error) {
    } finally {
    }
  };

  return (
    <div className="bg-white pb-10">
      <div className="section mx-auto px-4 lg:px-0">
        <BreadcrumbComp items={breadcrumbItems} />
        <div className="py-8">
          <div className="flex flex-col lg:flex-row gap-8">
            {/* Left Column: Job Details */}
            <div className="flex-1">
              <h1 className="text-2xl md:text-3xl font-bold text-[#1A1A1A] mb-4 uppercase leading-snug">
                {recruitment.title || ""}
              </h1>

              <div className="flex flex-wrap items-center text-[#555] text-sm gap-4 mb-8">
                <div className="flex items-center gap-1">
                  <AiOutlineClockCircle />
                  <span>{recruitment?.workingForm || ""}</span>
                </div>
                <div className="flex items-center gap-1">
                  <AiOutlineEnvironment />
                  <span>{recruitment?.address || ""}</span>
                </div>
              </div>

              <div className="space-y-6 text-[#333] text-sm leading-7 text-justify">
                {ReactParser(recruitment?.content)}
              </div>
            </div>

            <div className="w-full lg:w-[350px] shrink-0">
              <div className="border border-[#E5E5E5] p-6 lg:sticky lg:top-4 bg-[#FAFAFA]">
                <h3 className="text-lg font-bold text-[#1A1A1A] uppercase border-b border-[#E5E5E5] pb-4 mb-4">
                  TỔNG QUAN VỀ CÔNG VIỆC
                </h3>

                <div className="space-y-6 mb-6">
                  <div>
                    <p className="text-[#555] text-sm mb-1">Thu nhập</p>
                    <div className="flex items-center gap-2 font-bold text-[#28A7E8]">
                      <AiOutlineDollarCircle className="text-lg" />
                      <span>{recruitment?.salary || ""}</span>
                    </div>
                  </div>

                  <div>
                    <p className="text-[#555] text-sm mb-1">
                      Số lượng cần tuyển
                    </p>
                    <div className="flex items-center gap-2 font-medium text-[#333]">
                      <AiOutlineUser className="text-lg text-[#555]" />
                      <span>{recruitment?.quantity || ""}</span>
                    </div>
                  </div>

                  <div>
                    <p className="text-[#555] text-sm mb-1">Địa chỉ làm việc</p>
                    <div className="flex items-start gap-2 font-medium text-[#333]">
                      <AiOutlineEnvironment className="text-lg text-[#555] shrink-0 mt-1" />
                      <span className="text-sm">
                        {recruitment?.address || ""}
                      </span>
                    </div>
                  </div>

                  <div>
                    <p className="text-[#555] text-sm mb-1">Hạn ứng tuyển</p>
                    <div className="flex items-center gap-2 font-medium text-[#333]">
                      <AiOutlineClockCircle className="text-lg text-[#555]" />
                      <span>
                        Hạn nộp hồ sơ:{" "}
                        {recruitment?.expired
                          ? dayjs(recruitment?.expired).format("DD/MM/YYYY")
                          : ""}
                      </span>
                    </div>
                  </div>
                </div>

                <Button
                  onClick={showModal}
                  size="large"
                  shape="round"
                  type="primary"
                  className="w-full !text-white  py-2 px-4 rounded  !font-semibold transition-colors uppercase"
                >
                  Ứng tuyển ngay
                </Button>
              </div>
            </div>
          </div>
        </div>

        <Modal
          title="Ứng tuyển công việc"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={null}
          centered
        >
          <Form
            form={form}
            layout="vertical"
            name="recruitment_form"
            className="mt-4"
            onFinish={handleOk}
          >
            <Form.Item
              name="name"
              label="Họ và tên"
              rules={[{ required: true, message: "Vui lòng nhập họ tên!" }]}
            >
              <Input size="large" placeholder="Nhập họ và tên" />
            </Form.Item>

            <Form.Item
              name="phone"
              label="Số điện thoại"
              rules={[
                { required: true, message: "Vui lòng nhập số điện thoại!" },
                {
                  pattern: /(84|0[3|5|7|8|9])+([0-9]{8})\b/,
                  message: "Số điện thoại không hợp lệ!",
                },
              ]}
            >
              <Input size="large" placeholder="Nhập số điện thoại" />
            </Form.Item>

            <Form.Item
              name="email"
              label="Email"
              rules={[
                { required: true, message: "Vui lòng nhập Email!" },
                { type: "email", message: "Email không hợp lệ!" },
              ]}
            >
              <Input size="large" placeholder="Nhập email" />
            </Form.Item>

            <Form.Item
              name="upload"
              label="CV đính kèm"
              valuePropName="fileList"
              getValueFromEvent={(e) => {
                if (Array.isArray(e)) {
                  return e;
                }
                return e?.fileList;
              }}
              rules={[{ required: true, message: "Vui lòng tải lên CV!" }]}
            >
              <Upload
                name="file"
                listType="text"
                maxCount={1}
                customRequest={customRequest}
              >
                <Button icon={<UploadOutlined />}>Tải lên CV (PDF, DOC)</Button>
              </Upload>
            </Form.Item>

            <Form.Item className="mb-0 text-center">
              <Button
                htmlType="submit"
                size="large"
                shape="round"
                type="primary"
                className="w-full !text-white py-2 px-4 rounded  !font-semibold transition-colors uppercase"
              >
                Gửi hồ sơ
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </div>
  );
};

export default RecruitmentDetail;
